import { useState } from "react";

import type { AIContext } from "../../services/aiService";
import { apiErrorMessage } from "../../utils/apiError";
import AIAssistField from "../AIAssistField";
import { Field } from "../FormLayout";
import { ActionPanel } from "../register/DetailsModal";

export const errorLine = (error: unknown, fallback: string) => (
  <p role="alert" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{apiErrorMessage(error, fallback)}</p>
);

/** Calling something off: the reason is required and stays on the record. */
export function CancelPanel({ title, description, placeholder, context, button, busy, error, errorText, onCancel }: {
  title: string;
  description: string;
  placeholder: string;
  context: AIContext;
  button: string;
  busy: boolean;
  error: unknown;
  errorText: string;
  onCancel: (reason: string) => void;
}) {
  const [reason, setReason] = useState("");
  return (
    <ActionPanel title={title} description={description}>
      <Field label="Why" as="div">
        <AIAssistField
          rows={2}
          value={reason}
          onChange={(next) => setReason(next)}
          placeholder={placeholder}
          context={context}
          draftLabel="Draft the reason"
          draftHint="Jot why first, and it writes it up. It never guesses the reason."
        />
      </Field>
      <div className="flex justify-end">
        <button
          type="button"
          disabled={!reason.trim() || busy}
          onClick={() => onCancel(reason.trim())}
          className="rounded-md border border-red-200 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-50 disabled:opacity-50"
        >
          {busy ? "Cancelling…" : button}
        </button>
      </div>
      {Boolean(error) && errorLine(error, errorText)}
    </ActionPanel>
  );
}

/** A textarea with the transport writing assistant, for a form that posts by field name. */
export function AssistedText({ name, value, onChange, context, placeholder, rows = 3, draftHint }: {
  name: string;
  value: string;
  onChange: (value: string) => void;
  context: AIContext;
  placeholder?: string;
  rows?: number;
  draftHint: string;
}) {
  return (
    <>
      <AIAssistField rows={rows} value={value} onChange={(next) => onChange(next)} placeholder={placeholder} context={context} draftLabel="Help me write it" draftHint={draftHint} />
      <input type="hidden" name={name} value={value} />
    </>
  );
}
